import { EssHeader } from '@/components/ess/EssHeader';
import NoDataCard from '@/components/NoDataCard';
import { NavPage } from '@/components/page/Breadcrumbs';
import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { TableLoader } from '@/components/shared/table/TableLoader';
import { useUpcomingLeaveListItems } from '@/services/leaveManagement/useUpcomingLeaveListItems';
import { useMyId } from '@/services/staff/useMyId';
import { FunctionComponent, Suspense } from 'react';
import { FiClock } from 'react-icons/fi';
import essStrings from '../../../ess.translations';
import { MyScheduleLeaveRequestList } from './MyScheduleLeaveRequestList';

interface MyScheduleAllUpcomingLeavePageProps {}

const MyScheduleAllUpcomingLeavePage: FunctionComponent<MyScheduleAllUpcomingLeavePageProps> = () => {
  const userId = useMyId();

  const breadcrumbs: NavPage[] = [
    {
      name: essStrings.mySchedule.header,
      to: `/ess/my-schedule`
    }
  ];

  const { items: upcomingItems } = useUpcomingLeaveListItems(userId);

  return (
    <PageContainer>
      <EssHeader icon={FiClock} title={essStrings.mySchedule.leave.cardTitle} breadcrumbs={breadcrumbs} />
      <PageSizer mode={SizerMode.PAGE} className="flex-1 overflow-auto space-y-4">
        <Suspense fallback={<TableLoader />}>
          {upcomingItems.length > 0 ? (
            <MyScheduleLeaveRequestList items={upcomingItems} />
          ) : (
            <NoDataCard message={essStrings.mySchedule.leave.noLeave} />
          )}
        </Suspense>
      </PageSizer>
    </PageContainer>
  );
};

export default MyScheduleAllUpcomingLeavePage;
